import { ModalMain } from "../styled";
import { FontGreyDarkFullBold, FontGreyDarkFullRegular, FontGreyDarkMediumTitle } from "../../../../utils/typografyApp";
import SecondaryButton from "../../SecondaryButton";
import PrimaryButton from "../../PrimaryButton";
import { DeleteUserForm } from "./styled";
import { useDeleteUserModalHook } from "./hook";
import { FormProvider } from "react-hook-form";

const DeleteUserModal = ({ onClose, selectedUser }) => {

    const hook = useDeleteUserModalHook({ onClose, selectedUser });
    
    return (
        <ModalMain>
            <FormProvider {...hook.form.assetForm}>
                <DeleteUserForm>
                    
                        <div className={"menu-content"}>
                            <div className="content">
                                <div className="title">
                                    <FontGreyDarkMediumTitle>Deletar Usuário</FontGreyDarkMediumTitle>
                                </div>
                                <FontGreyDarkFullRegular>Tem certeza que deseja excluir o Usuário <FontGreyDarkFullBold> {selectedUser?.name}</FontGreyDarkFullBold>?</FontGreyDarkFullRegular>
                            </div>

                            <div className="actions-container">
                                <SecondaryButton disabled={hook.form.isLoading} onClick={onClose}>Voltar</SecondaryButton>
                                <PrimaryButton disabled={hook.form.isLoading} onClick={hook.form.onSubmit}> {hook.form.isLoading ? 'Excluindo...' : 'Excluir'} </PrimaryButton>
                            </div>
                        </div>
            
                </DeleteUserForm>
            </FormProvider>
        </ModalMain>
    );
}

export default DeleteUserModal;